import React, { Fragment } from 'react'
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-thai-datepickers'
// import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import moment from 'moment'
import MomentUtils from '@date-io/moment'
import 'moment/locale/th'
import { FormControl, FormHelperText, Grid, Typography } from '@material-ui/core'
import useDatepicker from './useDatepicker'
import { DatePickerViewProps, MyDatePickerProps } from './datepickerType'
import useLanguageStore from '../../stores/language/languageStore'
import { makeStyles } from '@material-ui/core/styles'
import { CalendarTodayOutlined } from '@material-ui/icons'

moment.locale('en') // set to eng
///view

const MyDatePickerView: React.FC<DatePickerViewProps> = ({
    onChangeValue,
    required,
    label,
    field,
    disabled,
    minDate,
    maxDate,
    clearable = true,
    disabledWeekend = false,
    icon = <CalendarTodayOutlined />,
    size = 'small',
    ...others
}) => {
    const { input, meta } = field
    const isError = meta.error && meta.invalid && meta.touched ? true : false
    const classes = useStyles(isError)

    const languageStore = useLanguageStore()

    React.useEffect(() => {
        if (languageStore.currentLanguage === 'th') {
            moment.locale('th') // set to thai
        } else {
            moment.locale('en') // set to eng
        }
    }, [languageStore.currentLanguage])

    const getLabel = () => {
        const myLabel = required ? (
            <Grid container className={classes.label}>
                <Grid item>
                    <Typography variant={'subtitle2'}>{label}</Typography>
                </Grid>
                <Grid item>
                    <Typography variant={'subtitle2'} style={{ color: 'red' }}>
                        *
                    </Typography>
                </Grid>
            </Grid>
        ) : (
            <Grid container className={classes.label}>
                <Grid item>
                    <Typography variant={'subtitle2'}>{label || ''}</Typography>
                </Grid>
            </Grid>
        )
        return <Typography variant={'subtitle2'}>{myLabel}</Typography>
    }

    return (
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={languageStore.currentLanguage}>
            <FormControl style={{ height: '108px', width: '100%' }}>
                {getLabel()}

                {/* <ThemeProvider theme={datePickerTheme}> */}
                <DatePicker
                    value={input.value ? moment(input.value) : null}
                    onChange={(newDate) => {
                        input.onChange(newDate?.format('YYYY-MM-DD'))
                        if (onChangeValue) {
                            onChangeValue(String(newDate?.format('YYYY-MM-DD')))
                        }
                    }}
                    inputVariant={'outlined'}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    InputProps={{
                        endAdornment: <Fragment>{icon && icon}</Fragment>,
                    }}
                    size={size}
                    onClose={input.onBlur} //เพื่อให้ onTouch จาก react final form เห็น
                    animateYearScrolling
                    variant="dialog"
                    format="DD MMM YYYY"
                    pickerHeaderFormat="ddd D MMMM"
                    yearOffset={languageStore.currentLanguage === 'th' ? 543 : undefined}
                    disabled={disabled}
                    clearable={clearable}
                    minDate={disabled ? undefined : minDate}
                    maxDate={disabled ? undefined : maxDate}
                    shouldDisableDate={
                        disabledWeekend
                            ? (date) => {
                                  return moment(date).day() === 0 || moment(date).day() === 6
                              }
                            : () => false
                    }
                    error={isError}
                    className={classes.disable}
                />

                <FormHelperText className={classes.errorText}>{isError && meta.error}</FormHelperText>
            </FormControl>
        </MuiPickersUtilsProvider>
    )
}

//Combind Logic&View Component

let MyDatePicker: React.FC<MyDatePickerProps> = ({ required, name, ...others }) => {
    const myDatePicker = useDatepicker({ required, name })
    return <MyDatePickerView {...myDatePicker} {...others} required={required} />
}

export default MyDatePicker

const useStyles = makeStyles((theme) => ({
    label: {
        marginBottom: 10,
        color: (isError: any) => {
            if (isError) {
                return '#ff4d4f'
            } else {
                return ''
            }
        },
    },
    errorText: {
        fontSize: '12px',
        color: '#ff4d4f',
    },
    disable: {
        '& .Mui-disabled': {
            color: '#000000',
            backgroundColor: '#F0F0F0C6',
        },
    },
}))
